/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Social_TitleInputs */

const en_lg_social_title = /** @type {(inputs: Lg_Social_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take a break together`)
};

const id_lg_social_title = /** @type {(inputs: Lg_Social_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ambil jeda bersama`)
};

/**
* | output |
* | --- |
* | "Take a break together" |
*
* @param {Lg_Social_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_social_title = /** @type {((inputs?: Lg_Social_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Social_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_social_title(inputs)
	return en_lg_social_title(inputs)
});